import { render, staticRenderFns } from "./AdminToolbar.vue?vue&type=template&id=04c28b1f&"
import script from "./AdminToolbar.vue?vue&type=script&lang=js&"
export * from "./AdminToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AdminToolbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
